<div class="{{class}} options-grid grid lg:grid-cols-3 lg:gap-y-8 sm:grid-cols-2 mobile:grid-cols-1 md:gap-6 sm:gap-6 mobile:gap-4" [formGroup]="baseForm">
    <!-- {{optionsObject|json}}-->
    <div class="option-item" formArrayName="options" *ngFor="let option of options.controls; let i = index">
        <ng-container [formGroupName]="i">
            <label class="product__option-label control-label h-6 line-clamp-1">
                {{translateHelper.localize(optionsObject[option.value?.optionId]?.name)}}
                @if(optionsObject[option.value?.optionId]?.required) {
                <span class="required-icon">*</span>
                }
            </label>
            <!-- <div class="product__option" *ngIf="optionsObject[option.value?.optionId]?.type === 'R'">
                <div class="input-radio-label">
                    <div class="input-radio-label__list">
                        <label *ngFor="let radioOption of optionsObject[option.value?.optionId]?.values | keyvalue">
                            <input
                                (change)="optionsEventService.setOptionEvent(true); checkCobination( optionsObject[option.value?.optionId],radioOption.key)"
                                formControlName="valueId" type="radio" [value]="radioOption.key">
                            <span>{{ translateHelper.localize(radioOption.value['name']) }}</span>
                        </label>
                    </div>
                </div>
            </div> -->
            @if(optionsObject[option.value?.optionId]?.type == ProductOptionType.ColorGroup) {
            <div class="product__option">
                <ng-container *ngIf="(optionsObject[option.value?.optionId]?.values| keyvalue).length < 5 else selectColor">
                    <div class="input-color-label">
                        <div class="input-color-label__list">
                            <ng-container *ngFor="let colorOption of optionsObject[option.value?.optionId]?.values | keyvalue; i as index">
                                <label>
                                    <input (change)="optionsEventService.setOptionEvent(true); checkCobination( optionsObject[option.value?.optionId],colorOption.key)" formControlName="valueId" type="radio" [value]="colorOption.key">
                                    <span [title]="colorOption.value?.code" [style]="'background:'+colorOption.value?.color"> </span>
                                </label>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
                <ng-template #selectColor>
                    <!-- <select
                    (change)="optionsEventService.setOptionEvent(true);  checkCobination(optionsObject[option.value?.optionId],option.get('valueId').value)"
                    class="form-control form-control-rounded" formControlName="valueId">
                    <option *ngFor="let colorOption of optionsObject[option.value?.optionId]?.values| keyvalue"
                    [value]="colorOption.key" [style]="'background:'+colorOption.value?.color">
                    <div class="flex flex-row items-center">
                        <div class='select-color' [title]="colorOption.value?.code"
                            [style]="'background:'+colorOption.value?.color"> </div>
                        <div class="ms-2 my-2">
                            {{colorOption.value?.code}}
                        </div>
                    </div>
                    </option>
                </select> -->
                    <div class="my-form-field">
                        <mat-form-field appearance="outline" class="flex-auto my-form-field w-full">
                            <mat-select (selectionChange)="optionsEventService.setOptionEvent(true); checkCobination(optionsObject[option.value?.optionId],option.get('valueId').value)" formControlName="valueId" [required]='optionsObject[option.value?.optionId]?.required'>
                                <mat-select-trigger>
                                    <div class="flex flex-row items-center">
                                        <div class='select-color' [title]="optionsObject[option.value?.optionId]?.values[optionsFormArray.at(i).get('valueId').value]?.code" [style]="'background:'+optionsObject[option.value?.optionId]?.values[optionsFormArray.at(i).get('valueId').value]?.color">
                                        </div>
                                        <div class="ms-2">
                                            {{optionsObject[option.value?.optionId]?.values[optionsFormArray.at(i).get('valueId').value]?.code}}
                                        </div>
                                    </div>
                                </mat-select-trigger>
                                <mat-option *ngFor="let colorOption of optionsObject[option.value?.optionId]?.values| keyvalue" [value]="colorOption.key">
                                    <div class="flex flex-row items-center">
                                        <div class='select-color' [title]="colorOption.value?.code" [style]="'background:'+colorOption.value?.color"> </div>
                                        <div class="ms-2">
                                            {{colorOption.value?.code}}
                                        </div>
                                    </div>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </ng-template>
            </div>
            } @else if ([ProductOptionType.SelectBox, ProductOptionType.RadioGroup, ProductOptionType.Checkbox].includes(optionsObject[option.value?.optionId]?.type)) {
            <div class="form-group product__option">
                <select (change)="optionsEventService.setOptionEvent(true);  checkCobination(optionsObject[option.value?.optionId],option.get('valueId').value)" class="form-control form-control-rounded" formControlName="valueId">
                    <option *ngIf="optionsObject[ option.value?.optionId]?.values" [value]="null" disabled> {{"select_option"|translate}} </option>
                    <option *ngFor="let selectOption of optionsObject[ option.value?.optionId]?.values | keyvalue" [value]="selectOption.key"> {{ translateHelper.localize(selectOption.value['name']) }}
                        <span *ngIf="optionsObject[ option.value?.optionId ]?.additive" class="option-price">
                            ({{selectOption.value?.price|currencyConvert : product.companyData.currencyMeta.code}})</span>
                    </option>
                </select>
            </div>
            } @else if(optionsObject[option.value?.optionId]?.type == ProductOptionType.File) {
            <!-- option type is File upload -->
            <div class="form-group product__option">
                <div class="flex flex-row gap-2">
                    <label for="file-upload-{{i}}" class="custom-file-upload">
                        {{'chooseFile'|translate}} <mat-icon svgIcon="arrow-up-eject"></mat-icon>
                    </label>
                    <input type="file" id="file-upload-{{i}}" (change)="fileBrowseHandler(option,$event.target.files, optionsObject[option.value?.optionId])" />
                    <div class="file-value cursor-pointer mt-2">
                        <span *ngIf="optionsObject[option.value?.optionId]?.file?.name" class="flex flex-row items-center">
                            <span class="line-clamp-1 w-24 break-all">{{optionsObject[option.value?.optionId]?.file?.name}}</span> <span appClick class="ms-2 cursor-pointer" (click)="remove(option,optionsObject[option.value?.optionId])">X</span>
                        </span>
                        @if(!optionsObject[option.value?.optionId]?.file?.name) {
                        <span>{{'noFile'|translate}}</span>
                        }
                    </div>
                </div>
            </div>
            } @else if(optionsObject[option.value?.optionId]?.type == ProductOptionType.Text) {
            <div class="form-group product__option">
                <!-- <textarea rows="3" class="form-control form-control-sm" [id]="option.value?.optionId" formControlName="value"></textarea> -->
                <input type="text" class="form-control form-control-rounded" [id]="option.value?.optionId" formControlName="value">
            </div>
            } @else if(optionsObject[option.value?.optionId]?.type == ProductOptionType.Date) {
            <div class="form-group product__option">
                <div class="flex mb-2">
                    <input class="form-control form-control-rounded date-input" formControlName="date" type="text" [attr.placeholder]="'choose_date'|translate" bsDatepicker [daysDisabled]="optionsObject[option.value?.optionId].values?.disabledDays" [minDate]="getMinmumDays(optionsObject[option.value?.optionId].values?.marginDays)" [bsConfig]="{ adaptivePosition: true, showWeekNumbers: false  }">
                </div>
                @if(optionsObject[option.value?.optionId]?.values?.timeList && options?.at(i)?.value?.date) {
                <div class="flex">
                    <select class="form-control form-control-rounded" formControlName="time">
                        <option [value]="null" disabled selected>{{"select_time"|translate}}</option>
                        <option *ngFor="let time of optionsObject[option.value?.optionId]?.values?.timeList" [value]="time">{{ time }}</option>
                    </select>
                </div>
                }
            </div>
            }

            <!-- option is Checkbox -->
            <!--  <div class="form-check" *ngIf="optionsObject[option.value?.optionId]?.type === 'C'">
                <div *ngFor=" let checkboxOption of optionsObject[ option.value?.optionId ]?.values | keyvalue">
                    <span class="form-check-input input-check">
                        <span class="input-check__body">
                            <input class="input-check__input" type="checkbox"
                                (change)="checkboxChange(option, checkboxOption.key)" [id]="option.value?.optionId"
                                formControlName="value" (change)="optionsEventService.setOptionEvent(true)" />
                            <span class="input-check__box rounded-full"></span>
                            <app-icon class="input-check__icon" name="selectChecked" size="9x7"></app-icon>
                        </span>
                    </span>
                    <label class="form-check-label"
                        [for]="option.value?.optionId">{{translateHelper.localize(checkboxOption?.value['name'])}}
                        <span *ngIf="optionsObject[ option.value?.optionId ]?.additive" class="option-price">
                            ({{checkboxOption.value?.price|currencyConvert : product.companyData.currencyMeta.code}})</span></label>
                </div>
            </div> -->
        </ng-container>
    </div>
</div>

<!--  {{options.value | json}} -->